import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, Stack } from '@mui/material';
import HelpTooltip from '../HelpTooltip';
import { BiHelpCircle } from 'react-icons/bi';
import FieldLock from '../FieldLock';

export type RadioValue = {
    helpTitle: string;
    helpBody: string;
    value: string;
    label: string;
    mandatory: boolean;
}

export interface FBRadioProps {
    row: boolean;
    labelId: string;
    value: string;
    onChange: (value: string) => void;
    valueList: RadioValue[];
    disabled: boolean;

    labelText: string;
    mandatory: boolean;
    helpTextTitle: string;
    helpTextBody: string;

    onLock: (field: string, locked: boolean) => void;
    disabledLock: boolean;
    displayedLock: boolean;
    isLocked: boolean;
}

const FBRadio = (props: FBRadioProps): JSX.Element => {

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        props.onChange(event.target.value);
    };

    return (
        <FormControl component="fieldset" sx={{ width: '100%' }}>
        <Stack direction="row" alignItems="center" spacing={2} flexWrap="nowrap">

            <FormLabel
            component="legend"
            htmlFor={props.labelId}
            sx={{ fontSize: '12px', whiteSpace: 'nowrap' }}
            >
            <FieldLock
                onChange={function (locked: boolean): void {
                    props.onLock(props.labelId,locked);
                } }
                labelId={props.labelId}
                disabled={props.disabledLock}
                displayed={props.displayedLock}
                value={props.isLocked}/>
                {props.labelText}
            </FormLabel>

            <RadioGroup
            row
            id={props.labelId}
            name={props.labelId}
            data-testid={props.labelId}
            value={props.value}
            onChange={handleInputChange}
            aria-label={props.labelText}
            sx={{
                display: 'flex',
                flexDirection: 'row',
                flexWrap: 'nowrap',
                gap: 1,
            }}
            >
            {props.valueList.map((value) => (
                <FormControlLabel
                data-testid={value.label}
                key={value.value}
                value={value.value}
                control={
                    <Radio sx={{ '& .MuiSvgIcon-root': { fontSize: 18 } }} />
                }
                label={
                    <span style={{ fontSize: '12px', whiteSpace: 'nowrap' }}>
                    {value.label}
                    <b>{value.mandatory ? ' *' : ''}</b>{' '}
                    <HelpTooltip title={value.helpTitle} body={value.helpBody}>
                        <BiHelpCircle />
                    </HelpTooltip>
                    </span>
                }
                disabled={props.disabled}
                sx={{ whiteSpace: 'nowrap' }}
                />
            ))}
            </RadioGroup>
        </Stack>
        </FormControl>
    );
/*
    return (
        <FormControl>
        <Stack direction="row" alignItems="center" spacing={2}>
            <FormLabel component="legend" htmlFor={props.labelId}
            sx={{ fontSize: '12px', whiteSpace: 'nowrap' }}>
                {props.labelText}
            </FormLabel>
          <RadioGroup
            row={props.row}
            id={props.labelId}
            name={props.labelId}
            data-testid={props.labelId}
            value={props.value}
            onChange={handleInputChange}
            aria-label={props.labelText}
        >
            {
                props.valueList.map(
                    value => (
                        <FormControlLabel
                        data-testid={value.label}
                        key={value.value}
                        sx={{ fontSize: '12px', whiteSpace: 'nowrap' }}
                        value={value.value}
                        control={<Radio sx={{ '& .MuiSvgIcon-root': { fontSize: 18 } }}/>}
                        label={
                            <span style={{ fontSize: '12px' }}>
                              {value.label} <b>{value.mandatory ? '* ' : ''}</b>{' '}

                                <span style={{ display: 'inline-block' }}>
                                <HelpTooltip title={value.helpTitle} body={value.helpBody}> <BiHelpCircle /> </HelpTooltip>
                                </span>
                            </span>
                        }
                        disabled={props.disabled}
                      />
                    )
                )
            }
        </RadioGroup>
        </Stack>
        </FormControl>
    );*/
  };

export default FBRadio;